import { FC } from 'react';

import { ResourceList } from '@portal/common/types';

import ListItem from './ListItem';

type Props = {
    items: ResourceList[];
    isPublic?: boolean;
};

const ListsMenu: FC<Props> = ({ items, isPublic }) =>
    items.map((list) => <ListItem key={list.id} list={list} isPublic={isPublic} />);

export default ListsMenu;
